module.exports = __webpack_public_path__ + "img/icon_kctg.82ac423d.png";